import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Card } from './ui/card';
import { Button } from './ui/button';
import { Lock, Crown, Star, ArrowRight } from 'lucide-react';

const SubscriptionGate = ({ requiredTier = 'tier1', featureName = 'this feature' }) => {
  const navigate = useNavigate();

  const tierInfo = {
    tier1: {
      name: 'Essential',
      icon: Star,
      color: 'primary',
      price: '$19/month'
    },
    tier2: {
      name: 'Premium',
      icon: Crown,
      color: 'secondary',
      price: '$29/month'
    }
  };

  const tier = tierInfo[requiredTier] || tierInfo.tier1;
  const Icon = tier.icon;

  return (
    <div className="min-h-[60vh] flex items-center justify-center p-4">
      <Card className="max-w-md w-full rounded-2xl p-8 text-center" data-testid="subscription-gate">
        <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-stone-100 mb-6">
          <Lock className="w-8 h-8 text-stone-400" />
        </div>
        
        <h2 className="text-2xl font-nunito font-bold text-[#2D2D2D] mb-2">
          Unlock {featureName}
        </h2>
        
        <p className="text-[#57534E] mb-6">
          This feature is available with the <span className="font-semibold text-{tier.color}">{tier.name}</span> plan. 
          Upgrade to access powerful tools for tracking and managing your child's health journey.
        </p>

        <div className="bg-stone-50 rounded-xl p-4 mb-6">
          <div className="flex items-center justify-center gap-2 mb-2">
            <Icon className={`w-5 h-5 text-${tier.color}`} />
            <span className="font-semibold text-[#2D2D2D]">{tier.name} Plan</span>
          </div>
          <p className="text-sm text-[#57534E]">Starting at {tier.price}</p>
        </div>

        <Button
          onClick={() => navigate('/pricing')}
          className={`w-full bg-${tier.color} hover:bg-${tier.color}/90 text-white`}
        >
          View Plans
          <ArrowRight className="w-4 h-4 ml-2" />
        </Button>
      </Card>
    </div>
  );
};

export default SubscriptionGate;
